import { ContractGestionAlerteFuiteDto } from './dtos/contract-gestion-alerte-fuite.dto';
import { axiosCore } from './http-core-service';

const url = '/rattachement_contrat_preferences/';

export const getContratPreferences = async (id: string | undefined): Promise<any> => {
    id = id?.replace(url, '');

    const response = await axiosCore.get(url + id);
    return response.data;
};

export const initContratPreferences = async (contratId: string | undefined): Promise<any> => {
    const response = await axiosCore.post(`${url}init/${contratId}`);
    return response.data;
};

export const updateContratPreferences = async (id: string, data: ContractGestionAlerteFuiteDto): Promise<any> => {
    if (id.includes(url)) {
        id = id?.replace(url, '');
    }
    const response = await axiosCore.patch(url + id, data);
    return response.data;
};
